import ParentBlock from "./template";

export default ParentBlock;